import React from 'react';
import { AuthProvider, useAuth } from './context/AuthContext';
import FarmManager from './FarmManager'; // We will create this component next
import Auth from './components/auth/Auth';

function App() {
    return (
        <AuthProvider>
            <AppContent />
        </AuthProvider>
    );
}

function AppContent() {
    const { currentUser } = useAuth();
    
    // If a user is logged in, show the main app, otherwise show the login/signup page.
    return currentUser ? <FarmManager /> : <Auth />;
}

export default App;